import context from '../../main.js';

export async function uploadChunk(query) {
  let url = `/upload/fileBlock?currentChunkSize=${query.perSize}&index=${query.index}&chunkSize=${query.filesize}&totalChunks=${query.chunkNumbers}`;
  let result = await context.$http({
    timeout: 1000 * 60 * 10,
    url: url,
    method: 'post',
    data: query.formData
  });
  if (result.data.code === 200) {
    return result.data.data;
  }
  return false;
}
export async function mergeBlock(body) {
  let result = await context.$http.post('/upload/mergeBlock', body);
  if (result.data.code === 200) {
    return result.data.data;
  }
  return false;
}

export async function videoCodeInfo(url) {
  let result = await context.$http.get(`/common/material/avinfo?key=${url}`);
  return result.data;
}
export async function videoResolution(url) {
  let result = await context.$http.get(`/common/material/avinfo?key=${url}`);
  if (result.data && result.data.streams && result.data.streams.length > 0) {
    for (let i = 0; i < result.data.streams.length; i++) {
      const stream = result.data.streams[i];
      let ratio = 1;
      if (stream.display_aspect_ratio) {
        let sizes = stream.display_aspect_ratio.split(':');
        if (sizes.length === 2) {
          ratio = parseInt(sizes[0]) / parseInt(sizes[1]);
        }
      }
      let width = stream.width || stream.coded_width;
      let height = stream.height || stream.coded_height;
      if (!width || !height) continue;
      let sizeRatio = width / height;

      if ((sizeRatio > 1 && ratio < 1) || (sizeRatio < 1 && ratio > 1)) {
        //不同比例互换宽高
        return { width: height, height: width };
      } else {
        return { width: width, height: height };
      }
    }
  }
  return null;
}
